/**
 * Shared layout class names for the NCCN evaluation panel.
 * @module nccnEvaluationPanelStyles
 */

/** Root panel flex container; fills the space left of the resizable divider. */
export const NCCN_PANEL_ROOT_CLASS =
  "flex min-w-0 flex-1 flex-col overflow-hidden";

/** Fixed header bar matching the PDF toolbar height. */
export const NCCN_PANEL_HEADER_BAR_CLASS =
  "flex h-[3.75rem] shrink-0 items-center border-b border-primaryGray-15 px-4";

/**
 * Secondary Back footer button. Sizes to its label (no fixed width) so the
 * footer can compress when the analysis panel is at its minimum width.
 */
export const NCCN_PANEL_FOOTER_BACK_CLASS =
  "flex h-8 shrink-0 items-center justify-center whitespace-nowrap " +
  "rounded-[0.25rem] border border-[#0F0F0F] bg-white px-4 text-[0.75rem] " +
  "font-bold leading-[1.125rem] text-[#0F0F0F] [font-family:Lato] " +
  "disabled:cursor-not-allowed disabled:opacity-50";

/**
 * Primary Next / Review / Done footer button. Sizes to its label (no fixed
 * width) so the footer can compress when the analysis panel is at its minimum
 * width.
 */
export const NCCN_PANEL_FOOTER_PRIMARY_CLASS =
  "flex h-8 shrink-0 items-center justify-center whitespace-nowrap " +
  "rounded-[0.25rem] bg-[#0F0F0F] px-4 text-[0.75rem] font-bold " +
  "leading-[1.125rem] text-white [font-family:Lato] " +
  "disabled:cursor-not-allowed disabled:opacity-50";
